import styled from '@emotion/styled';
import React from 'react';
import { MergeWithOverwrite } from 'src/common';
import { colors } from 'src/theme';

const IconSpan = styled.span<{ height: number; width: number }>(({ height, width }) => ({
  display: 'inline-flex',
  height,
  width,
}));

export type DownloadIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number;
  height?: number;
  color?: string;
}>;

export const DownloadIcon: React.FC<DownloadIconProps> = ({
  width = 16,
  height = 16,
  color = colors.primary,
  ...props
}) => (
  <IconSpan height={height} width={width} {...props}>
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 12H0V11H12V12ZM6.5 8.29297L10 4.79297L10.707 5.5L6 10.207L1.29297 5.5L2 4.79297L5.5 8.29297V0H6.5V8.29297Z" fill={color} />
    </svg>
  </IconSpan>
);
